import { anonymousRequest, authRequest, ACCESS_TOKEN } from './auth';

const placeOrder = async (form) => {
  if (window.localStorage.getItem(ACCESS_TOKEN) === null) {
    return anonymousRequest.post('/orders/', form)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
  } else {
    return authRequest.post('/orders/', form)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
  }
}

const getOrders = async () => {
  return authRequest.get('/orders/')
  .then((response) => Promise.resolve(response.data))
  .catch((error) => Promise.reject(error));
}

const getOrderDetail = async (orderNumber) => {
  return authRequest.get(`/orders/${orderNumber}/`)
  .then((response) => Promise.resolve(response.data))
  .catch((error) => Promise.reject(error));
}

export { placeOrder, getOrders, getOrderDetail };